/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Button, Typography } from '@mui/material';
import { fonts, themes } from '../../themes/themes';

interface handleClick {
  onClickSubmit?: any;
  title?: string;
  textTransform?: any;
  disable?: boolean;
  children?: ReactNode;
  fontSize?: any;
  padding?: any;
}

const CustomAcceptButton: React.FC<handleClick> = ({
  onClickSubmit,
  title,
  textTransform = 'none',
  disable = false,
  children,
  fontSize,
  padding,
}) => {
  const enabledStyle = {
    minWidth: '123px',
    margin: '5px',
    maxWidth: 'fitContent',
    height: 'auto',
    maxHeight: '52px',
    color: 'White',
    boxShadow: '0px 2px 2px #00000061',
    backgroundColor: themes.primaryMain,
    borderRadius: '4px',
    fontFamily: fonts.fontFamily,
    textTransform: textTransform,
    cursor: 'pointer',
  };

  const disabledStyle = {
    display: 'flex',
    gap: '0 10px',
    cursor: 'not-allowed',
    minWidth: '118px',
    maxWidth: 'fitContent',
    height: 'auto',
    maxHeight: '42px',
    color: 'White',
    boxShadow: '0px 2px 2px #00000061',
    backgroundColor: themes.greyDefault,
    borderRadius: '4px',
    fontFamily: fonts.fontFamily,
    textTransform: textTransform,
  };

  return (
    <Button
      style={disable ? { ...disabledStyle } : enabledStyle}
      onClick={onClickSubmit}
      disabled={disable}
    >
      <Typography padding={padding} fontSize={fontSize}>
        {title}
        {children}
      </Typography>
    </Button>
  );
};

export default CustomAcceptButton;
